// src/app/store/version/version.effects.ts
import { inject } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { Actions, ofType } from '@ngrx/effects';
import { VersionService } from '../../services/version.service';
import * as VersionActions from './version.actions';
import { catchError, map, mergeMap, of } from 'rxjs';

export const loadBackendVersion$ = createEffect(
  (
    actions$ = inject(Actions),
    versionService = inject(VersionService)
  ) =>
    actions$.pipe(
      ofType(VersionActions.loadBackendVersion),
      mergeMap(() =>
        versionService.getBackendVersion().pipe(
          map(version => VersionActions.loadBackendVersionSuccess({ version })),
          catchError(error => of(VersionActions.loadBackendVersionFailure({ error })))
        )
      )
    ),
  { functional: true }
);

export const VersionEffects = {
  loadBackendVersion$
};
